import { ICryoShipmentsPending } from '@nkr/models/index';

export interface ICryoShipmentPending extends ICryoShipmentsPending {
    trackingNumber: string;
}